import { render, staticRenderFns } from "./create-transfer-protocol-modal.vue?vue&type=template&id=322f7a53&scoped=true"
import script from "./create-transfer-protocol-modal.vue?vue&type=script&lang=js"
export * from "./create-transfer-protocol-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f7a53",
  null
  
)

export default component.exports